import React, { type FC, memo, useCallback } from "react";

import { SortAssistantInline } from "@dms/components/DmsSortAssistant/SortAssistantInline";

import type { AgentPanelProps } from "./agentPanels";

const SortAssistantAgentPanelImpl: FC<AgentPanelProps> = ({ panel, onDone }) => {
    const onResult = panel.type === "sortAssistant" ? panel.onResult : undefined;
    const handleDone = useCallback(
        (answered: number, later: number) => {
            onResult?.(answered, later);
            onDone("done");
        },
        [onResult, onDone],
    );
    if (panel.type !== "sortAssistant") return null;
    return <SortAssistantInline steps={panel.steps} onDone={handleDone} />;
};

export const SortAssistantAgentPanel = memo(SortAssistantAgentPanelImpl);
